import { render, staticRenderFns } from "./PanelViewMenu.vue?vue&type=template&id=65357774"
import script from "./PanelViewMenu.vue?vue&type=script&lang=js"
export * from "./PanelViewMenu.vue?vue&type=script&lang=js"
import style0 from "./PanelViewMenu.vue?vue&type=style&index=0&id=65357774&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports